import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useContent } from "@/lib/content";

const OWNED = 'title, [data-seo], meta[name="description"], meta[name="robots"], link[rel="canonical"], meta[property^="og:"], meta[name^="twitter:"], meta[name="google-site-verification"], meta[name="msvalidate.01"], script[type="application/ld+json"]';

export const normPath = (p) => p.replace(/\/+$/, "") || "/";

const add = (tag, attrs, text) => {
    const el = document.createElement(tag);
    Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
    el.setAttribute("data-seo", "1");
    if (text !== undefined) el.textContent = text;
    document.head.appendChild(el);
};

// Single owner of SEO head tags: removes server/static copies, then writes one set per route.
export const SeoHead = () => {
    const { pathname } = useLocation();
    const { seo } = useContent();
    useEffect(() => {
        if (!seo) return;
        const m = seo.pages[normPath(pathname)];
        const keepTitle = document.title;
        document.head.querySelectorAll(OWNED).forEach((el) => el.remove());
        if (!m) {
            add("title", {}, keepTitle || seo.site_name);
            add("meta", { name: "robots", content: "noindex, nofollow" });
            return;
        }
        add("title", {}, m.title);
        const metas = [["name", "description", m.description], ["name", "robots", m.robots], ["property", "og:type", "website"],
            ["property", "og:site_name", m.site_name], ["property", "og:locale", "it_IT"], ["property", "og:title", m.og_title],
            ["property", "og:description", m.og_description], ["property", "og:url", m.canonical], ["property", "og:image", m.og_image],
            ["name", "twitter:card", "summary_large_image"], ["name", "twitter:title", m.og_title],
            ["name", "twitter:description", m.og_description], ["name", "twitter:image", m.og_image]];
        if (seo.verification.google) metas.push(["name", "google-site-verification", seo.verification.google]);
        if (seo.verification.bing) metas.push(["name", "msvalidate.01", seo.verification.bing]);
        metas.forEach(([k, n, v]) => add("meta", { [k]: n, content: v }));
        add("link", { rel: "canonical", href: m.canonical });
        m.jsonld.forEach((j) => add("script", { type: "application/ld+json" }, JSON.stringify(j).replace(/</g, "\\u003c").replace(/>/g, "\\u003e").replace(/&/g, "\\u0026")));
    }, [pathname, seo]);
    return null;
};
